import * as _state from './state';

const setSettingsField = async (field, value) => {
    let settings = getSettings();

    settings[field] = value;

    setSettings(settings);
}

// getters
const getSettings = () => {
    return _state.get('config/getConfig')['settings'];
}

// getters
const setSettings = (settings) => {
    _state.setField('config/getConfig', 'config/setConfig', 'settings', settings);
}

export {
    getSettings,
    setSettingsField,
}
